import React from "react";

import NoneAuthLayoutSwitch from "../none-auth-layout-switch";
import { BrandingData } from "admin-portal/settings/branding";
import ForgetPasswordComponent from "./forget-password-component";

const AdminForgetPasswordPage = (props: any) => {
  document.title = "Forget Password" + BrandingData.titleSuffix;

  return (
    <React.Fragment>
      <NoneAuthLayoutSwitch>
        <ForgetPasswordComponent />
      </NoneAuthLayoutSwitch>
    </React.Fragment>
  );
};

export default AdminForgetPasswordPage;
